export default __webpack_public_path__ + "static/img-2-e8ec31aa107270eb58c2bed1e92dbb20.png";